import { Header, Text } from '@rbilabs/universal-components';

export const HeadingText = Header.withConfig({
  textAlign: 'center',
});

export const BodyText = Text.withConfig({
  fontSize: 'md',
  textAlign: 'center',
  marginBottom: '$4',
});
